

import {consoleLog} from '../commonFunctions.js';
import config from "../../aws-exports";
import secureLocalStorage from "react-secure-storage";
import { navigate } from "gatsby";
let socket = null;
let reconnectTimeout = null;

export const subcribeWebSocket = async () => {

    const connect = () => {
        let client_data = JSON.parse(secureLocalStorage.getItem('client_data'));
        let client_email = client_data.username;

        consoleLog("Validate OKTA Session");

        socket = new WebSocket(
            process.env.GATSBY_AWS_API_GATEWAY_WEB_SOCKET +
            "?app_name=prodocs&user_email=" + client_email
        );

        socket.onopen = () => {
            console.log("Connected to WebSocket!");
            if (reconnectTimeout) {
                clearTimeout(reconnectTimeout);
                reconnectTimeout = null;
            }
        };

        socket.onmessage = (event) => {
            let data = event.data;

            if (typeof data === "string") {
                data = JSON.parse(data);
            }

            console.log("Received:", data);

            if (data.action === "okta_session_termination") {
                navigate("/session-ended");
            }
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        socket.onclose = () => {
            console.warn("WebSocket disconnected… reconnecting in 3 seconds");

            reconnectTimeout = setTimeout(() => {
                connect();
            }, 1000);
        };
    };

    // Start the initial connection
    connect();
};



